import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { Table, TableBody, TableHead, TableCell, TableRow, Grid, CircularProgress, Card, CardContent } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import NewHeaderInicio from '../../util/NewHeaderInicio'
// import question from '../../../assets/svg/question.png'
import IViewPostulaciones from '../../view-interfaces/IViewPostulaciones';
import IViewDeudaFinanciera from '../../view-interfaces/IViewDeudaFinanciera';
import { ObtienePostulacionesLogic, useStylesList, ObtieneDeudaBibliotecaLogic, ObtieneDeudaFinancieraLogic, ObtieneDocumentoLEMLogic } from '../../view-model/Inicio/PostulacionesEstudiante.logic';
import { ObtieneProcesoActualLogic } from '../../view-model/Parametros/Parametros.logic';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, InputLabel, Paper, PaperProps } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert/Alert';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
import HeaderInicio from '../../util/headerInicio';
import { Modal } from 'office-ui-fabric-react';
import MensajeToken from '../../../Components/MensajeToken/MensajeToken';
type Props = { rut: number }
const CarrerasPostuladas: React.FC<Props> = ({ rut = 0 }) => {
  const history = useHistory();
  const location = useLocation();

  const lista: Array<IViewPostulaciones> = []; //IViewPostulaciones
  const [listaPostulaciones, setListaPostulaciones] = useState(lista);
  const [rutParametro, setRutParametro] = useState(0);
  const [accesoInicio, setAccesoInicio] = useState("");
  const [accesoFin, setAccesoFin] = useState("");
  const [nombreAlumnoParam, setNombreAlumnoParam] = useState('');
  const [loading, setLoading] = useState(false);

  const [agnoActual, setAgnoActual] = useState(0)
  const [periodoActual, setPeriodoActual] = useState(0)

  const deudaFinancieraL: IViewDeudaFinanciera = {
    autorizadoMatricula: false,
    autorizadoTomaRamo: false,
    rutCliente: 0,
    tieneDeuda: false,
  };
  const [deudaFinanciera, setDeudaFinanciera] = useState(deudaFinancieraL);
  const [deudaBiblioteca, setDeudaBiblioteca] = useState(false)
  const [documentoLEM, setDocumentoLEM] = useState(false)
  const [yaMatriculado, setYaMatriculado] = useState(false)

  const [openModal, setOpenModal] = useState(false)
  const [mnsjDeudas, setMnsjDeudas] = useState('')

  const [cargandoValores, setCargandoValores] = useState(true)

  const [error, setError] = useState(false)
  const [reintentar, setReintentar] = useState(false)
  const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
  const [codNegocio, setCodNegocio] = useState(0)
  useEffect(() => {
    if (reintentar) {
      setError(false)
      if (location.state === null || location.state === undefined) {
        history.push({
          pathname: "/Inicio"
        });
      }
      else {
        setCargandoValores(true)
        setLoading(true);
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        console.log(_params)
        if (rut === 0) {
          ObtienePostulacionesLogic(selListaPostulaciones, _params.headers, Number(_params.rut), 0, 0, 1);
          setRutParametro(Number(_params.rut));
          console.log("NOMBRE ALUMNO CARRERA 1")
          console.log(_params.nombreAlumno);
          setNombreAlumnoParam(_params.nombreAlumno);
          ObtieneProcesoActualLogic(selListaProcesoActual);
        }
        else {
          ObtienePostulacionesLogic(selListaPostulaciones, _params.headers, rut, 0, 0, 1);
          console.log("NOMBRE ALUMNO CARRERA 2");
        }
      }
      setReintentar(false)
    }
  }, [reintentar])
  const selListaPostulaciones = (error: Boolean, err: string, Postulaciones: IViewPostulaciones[]) => {
    if (error === false && Postulaciones !== undefined) {
      setListaPostulaciones(Postulaciones);
      //setAccesoInicio(Postulaciones[0].accesoInicio != null && Postulaciones[0].accesoInicio != undefined ? Postulaciones[0].accesoInicio : "");
      //setAccesoFin(Postulaciones[0].accesoFin != null && Postulaciones[0].accesoFin != undefined ? Postulaciones[0].accesoFin : "");
      setCargandoValores(false);
    } else {
      if (err != "500") {
        setOpenModalToken({ open: true, mnsj: err })

      } else {
        setError(true);
      }
    }

    setLoading(false);
  }

  useEffect(() => {

    if (location.state === null || location.state === undefined) {
      history.push({
        pathname: "/Inicio"
      });
    }
    else {
      setCargandoValores(true)
      setLoading(true);
      let _tt = JSON.stringify(location.state);
      let _params = JSON.parse(_tt);
      console.log(_params)
      if (rut === 0) {
        //let _tt = JSON.stringify(location.state, ["rut"]);
        ObtienePostulacionesLogic(selListaPostulaciones, _params.headers, Number(_params.rut), 0, 0, 1);
        setRutParametro(Number(_params.rut));
        setNombreAlumnoParam(_params.nombreAlumno);
        ObtieneProcesoActualLogic(selListaProcesoActual);
      }
      else {
        ObtienePostulacionesLogic(selListaPostulaciones, _params.headers, rut, 0, 0, 1);
      }
    }
  }, [rut])

  const selListaProcesoActual = (error: Boolean, err: string, data: any) => {
    try {
      if (error === false) {
        let _tt = JSON.stringify(location.state);
        let _rut = JSON.parse(_tt);
        /* console.log(data) */
        setPeriodoActual(parseInt(data.periodo));
        setAgnoActual(data.ano);
        ObtieneDeudaFinancieraLogic(selListaDeudaFinanciera, _rut.headers, Number(_rut.rut));
        ObtieneDeudaBibliotecaLogic(selListaDeudaBiblioteca, Number(_rut.rut), data.ano, parseInt(data.periodo));
        ObtieneDocumentoLEMLogic(selListaDocumentoLEM, Number(_rut.rut), data.ano, parseInt(data.periodo));

      }
    } catch (err) {
      console.log('error', err)
    }
  }
  const selListaDeudaFinanciera = (error: Boolean, err: string, data: IViewDeudaFinanciera) => {
    try {
      if (error === false) {
        /* console.log(data) */
        setDeudaFinanciera(data);
      } else {
        if (err != "500") {
          setOpenModalToken({ open: true, mnsj: err })
        }
      }
    } catch (err) {
      console.log('error', err)
    }
  }
  const selListaDeudaBiblioteca = (error: Boolean, err: string, data: any) => {
    try {
      if (error === false) {
        setDeudaBiblioteca(data);
        /* console.log(data) */
      }
    } catch (err) {
      console.log('error', err)
    }
  }
  const selListaDocumentoLEM = (error: Boolean, err: string, data: any) => {
    try {
      if (error === false) {
        /* console.log(data) */
        setDocumentoLEM(data);
      }
    } catch (err) {
      console.log('error', err);
    }
  }

  useEffect(() => {
    let deudafinanciera_aux = deudaFinanciera.tieneDeuda ? "Tiene Deuda financiera" : ""
    let deudaBiblioteca_aux = deudaBiblioteca ? "Tiene Deuda biblioteca" : ""
    let deudaDocumentoLEM_aux = documentoLEM ? "Debe documento LEM" : ""

    if ((!deudaFinanciera.autorizadoMatricula || deudaFinanciera.tieneDeuda) && deudaBiblioteca && documentoLEM) {
      setMnsjDeudas(deudafinanciera_aux + " - " + deudaBiblioteca_aux + " - " + deudaDocumentoLEM_aux)
    } else if ((!deudaFinanciera.autorizadoMatricula || deudaFinanciera.tieneDeuda) && !deudaBiblioteca && documentoLEM) {
      setMnsjDeudas(deudafinanciera_aux + " - " + deudaDocumentoLEM_aux)
    } else if ((!deudaFinanciera.autorizadoMatricula || deudaFinanciera.tieneDeuda) && deudaBiblioteca && !documentoLEM) {
      setMnsjDeudas(deudafinanciera_aux + " - " + deudaBiblioteca_aux)
    } else if ((deudaFinanciera.autorizadoMatricula || !deudaFinanciera.tieneDeuda) && deudaBiblioteca && documentoLEM) {
      setMnsjDeudas(deudaBiblioteca_aux + " - " + deudaDocumentoLEM_aux)
    } else if ((deudaFinanciera.autorizadoMatricula || !deudaFinanciera.tieneDeuda) && !deudaBiblioteca && documentoLEM) {
      setMnsjDeudas(deudaDocumentoLEM_aux)
    } else if ((deudaFinanciera.autorizadoMatricula || !deudaFinanciera.tieneDeuda) && deudaBiblioteca && !documentoLEM) {
      setMnsjDeudas(deudaBiblioteca_aux)
    } else if ((!deudaFinanciera.autorizadoMatricula || deudaFinanciera.tieneDeuda) && !deudaBiblioteca && !documentoLEM) {
      setMnsjDeudas(deudafinanciera_aux)
    } else if ((deudaFinanciera.autorizadoMatricula || !deudaFinanciera.tieneDeuda) && !deudaBiblioteca && !documentoLEM) {
      setMnsjDeudas('')
    }

  }, [documentoLEM, deudaBiblioteca, deudaFinanciera])

  const classes = useStylesList();
  // console.log(listaPostulaciones)
  return (
    <>
      <HeaderInicio mostrarCallCenter={true} />
      {error ?
        <div className="site-main__container">
          <div className="site-main__title">Carreras / Programas disponibles:</div>
          {/* <div className="container"> */}
          <div>
            <p style={{ color: 'gray', fontSize: '1rem' }} className="enrollment__back">A continuación encontrarás los programas que tienes disponibles para Matrículas:</p>
          </div>
          <div style={{ textAlign: 'center', marginTop: 100 }}>

            <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
            <br />
            <a><span>Ocurrió un problema al obtener tus carreras/programas, favor comunicarse con la universidad.</span></a>
            <br />
            <Button style={{ border: '1px solid gray' }} onClick={() => setReintentar(true)} color="inherit">Reintentar cargar carreras/programas</Button>

          </div>
        </div>
        :
        <div className="site-main__container">
          <div className="site-main__title">Carreras / Programas disponibles:</div>
          {/* <div className="container"> */}
          <div>
            <p style={{ color: 'gray', fontSize: '1rem' }} className="enrollment__back">A continuación encontrarás los programas que tienes disponibles para Matrículas:</p>
          </div>
          {/* <div style={{float:'right'}}><img style={{ cursor: 'pointer' }} width={20} height={20} src={question} onClick={() => {
                    setOpenModal(true)
                  }} ></img></div> */}
          {cargandoValores ?
            <div className="site-main__container">
              <div style={{ textAlign: 'center', marginTop: 100 }}>

                <CircularProgress disableShrink />
                <br />
                <a><span>Cargando datos.</span></a>

              </div>
            </div>
            :
            <div>
              <Grid container item xs={12} sm={12} md={12} direction="column" >
                <Card elevation={0}>
                  <CardContent>
                    <Grid container direction="row"  >
                      {listaPostulaciones.length > 0 ?
                        listaPostulaciones.map((row) => {
                          return (
                            <div className={"rounded"} style={{ border: "1px solid #0062a1", padding: 20, marginBottom: 10, marginRight: 10, backgroundColor: 'rgb(246 251 255)' }}>
                              <Grid item xs={12} sm={6} md={4} direction="column">
                                <p className="text-center" style={{ inlineSize: 'fit-content', width: '15rem' }}>
                                  <h4 className="card-title text-center font-weight-bold noWrap" style={{ height: 50 }}><u>{row.nombreCarrera}</u></h4>
                                  <span className="card-text text-center font-weight-normal">{row.negocio}</span>
                                  <br></br>
                                  <span className="card-text text-center font-weight-normal">{row.codsede === "CONCEPCION" ? "CONCEPCIÓN" : row.codsede}</span>
                                  <br></br>
                                  <span className="card-text text-center font-weight-normal">{(row.negocio !== "PREGRADO" ? row.fechaInicio : '')}</span>
                                  <br></br>
                                  {
                                    (row.accesoInicio != "" && row.accesoFin != "") && (new Date(row.accesoInicio!) > new Date()) ?
                                      <Alert style={{ width: '100%' }} variant="outlined" severity="info">La plataforma de matrícula web para alumnos de pregrado estará disponible a partir del  <span style={{ display: 'inline-block' }}>{new Date(row.accesoInicio!).toLocaleDateString()}</span> a las <span style={{ display: 'inline-block' }}>{new Date(row.accesoInicio!).toLocaleTimeString().substring(0, 5)} hrs.</span></Alert>
                                      :
                                      (row.accesoInicio != "" && row.accesoFin != "") && (new Date(row.accesoInicio!) < new Date()) && (new Date(row.accesoFin!) < new Date()) ?
                                        <Alert style={{ width: '100%' }} variant="outlined" severity="info">El periodo actual no está habilitado para realizar su proceso de matrícula de pregrado. Ante cualquier duda por favor comunicarse a través de <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/"><u>https://contacto.udd.cl/</u></a></Alert>
                                        :
                                        row.matriculado === 1 ?
                                          mnsjDeudas === '' ?
                                            <p style={{ marginTop: 10 }} data-type={'light'} data-tip={"Carrera/Programa ya matriculada"}><Button
                                              variant="contained"
                                              color="primary"
                                              size="small"
                                              defaultValue={row.numeroAlumno}
                                              disabled={row.matriculado === 1 ? true : (deudaBiblioteca || documentoLEM || !deudaFinanciera.autorizadoMatricula) ? true : false}
                                              onClick={() => {
                                                let _tt = JSON.stringify(location.state);
                                                let _params = JSON.parse(_tt);
                                                history.push({
                                                  pathname: "/instrucciones",
                                                  state: {
                                                    rut: rutParametro,
                                                    nombreAlumno: nombreAlumnoParam,
                                                    codCarrera: row.codCarrera,
                                                    codigoNegocio:
                                                      (row.negocio === "PREGRADO" ? 1 :
                                                        (row.negocio === "POSTGRADO" ? 2 :
                                                          (row.negocio === "EXTENSION" || row.negocio === "EXTENSIÓN" ? 3 : 0))),
                                                    codigoPlanificacionAcademica: 0,//row.codPlanificacionAcademica
                                                    codsede: row.codsede,
                                                    nombreCarrera: row.nombreCarrera,
                                                    numeroAlumno: row.numeroAlumno,
                                                    anioPromocion: row.ano,
                                                    periodoPromocion: row.periodo,
                                                    headers: _params.headers
                                                  }
                                                });
                                                sessionStorage.setItem('codCarrera', JSON.stringify(row.codCarrera));
                                                sessionStorage.setItem('nombreCarrera', JSON.stringify(row.nombreCarrera));
                                                sessionStorage.setItem('codsede', JSON.stringify(row.codsede));
                                                sessionStorage.setItem('fase', JSON.stringify('instrucciones'))
                                              }}
                                            >Comenzar
                                            </Button><ReactTooltip /></p> :
                                            <p style={{ marginTop: 10 }} data-type={'light'} data-tip={"Carrera/Programa ya matriculada - " + mnsjDeudas}><Button
                                              variant="contained"
                                              color="primary"
                                              size="small"
                                              defaultValue={row.numeroAlumno}
                                              disabled={row.matriculado === 1 ? true : (deudaBiblioteca || documentoLEM || !deudaFinanciera.autorizadoMatricula) ? true : false}
                                              onClick={() => {
                                                let _tt = JSON.stringify(location.state);
                                                let _params = JSON.parse(_tt);
                                                history.push({
                                                  pathname: "/instrucciones",
                                                  state: {
                                                    rut: rutParametro,
                                                    nombreAlumno: nombreAlumnoParam,
                                                    codCarrera: row.codCarrera,
                                                    codigoNegocio:
                                                      (row.negocio === "PREGRADO" ? 1 :
                                                        (row.negocio === "POSTGRADO" ? 2 :
                                                          (row.negocio === "EXTENSION" || row.negocio === "EXTENSIÓN" ? 3 : 0))),
                                                    codigoPlanificacionAcademica: 0,//row.codPlanificacionAcademica
                                                    codsede: row.codsede,
                                                    nombreCarrera: row.nombreCarrera,
                                                    numeroAlumno: row.numeroAlumno,
                                                    anioPromocion: row.ano,
                                                    periodoPromocion: row.periodo,
                                                    headers: _params.headers
                                                  }
                                                });
                                                sessionStorage.setItem('codCarrera', JSON.stringify(row.codCarrera));
                                                sessionStorage.setItem('nombreCarrera', JSON.stringify(row.nombreCarrera));
                                                sessionStorage.setItem('codsede', JSON.stringify(row.codsede));
                                                sessionStorage.setItem('fase', JSON.stringify('instrucciones'))
                                              }}
                                            >Comenzar
                                            </Button><ReactTooltip /></p> :
                                          <p style={{ marginTop: 10 }} data-type={'light'} data-tip={mnsjDeudas}><Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            defaultValue={row.numeroAlumno}
                                            disabled={row.matriculado === 1 ? true : (deudaBiblioteca || documentoLEM || !deudaFinanciera.autorizadoMatricula) ? true : false}
                                            onClick={() => {
                                              let _tt = JSON.stringify(location.state);
                                              let _params = JSON.parse(_tt);
                                              history.push({
                                                pathname: "/instrucciones",
                                                state: {
                                                  rut: rutParametro,
                                                  nombreAlumno: nombreAlumnoParam,
                                                  codCarrera: row.codCarrera,
                                                  codigoNegocio:
                                                    (row.negocio === "PREGRADO" ? 1 :
                                                      (row.negocio === "POSTGRADO" ? 2 :
                                                        (row.negocio === "EXTENSION" || row.negocio === "EXTENSIÓN" ? 3 : 0))),
                                                  codigoPlanificacionAcademica: 0,//row.codPlanificacionAcademica
                                                  codsede: row.codsede,
                                                  nombreCarrera: row.nombreCarrera,
                                                  numeroAlumno: row.numeroAlumno,
                                                  anioPromocion: row.ano,
                                                  periodoPromocion: row.periodo,
                                                  headers: _params.headers
                                                }
                                              });
                                              sessionStorage.setItem('codCarrera', JSON.stringify(row.codCarrera));
                                              sessionStorage.setItem('nombreCarrera', JSON.stringify(row.nombreCarrera));
                                              sessionStorage.setItem('codsede', JSON.stringify(row.codsede));
                                              sessionStorage.setItem('fase', JSON.stringify('instrucciones'))
                                            }}
                                          >Comenzar
                                          </Button><ReactTooltip /></p>}
                                </p>
                              </Grid>
                            </div>
                          )
                        })
                        : <Alert /* style={{ width: '30rem' }} */ variant="outlined" severity="warning">No tenemos carreras posibles de matricular</Alert>
                      }
                      {/* {
                          (accesoInicio != "" || accesoFin != "") && (new Date(accesoInicio!) > new Date()) ?
                          <Alert style={{ width: '100%' }} variant="outlined" severity="info">La plataforma de matrícula web para alumnos de pregrado estará disponible a partir del  <span style={{display: 'inline-block'}}>{new Date(accesoInicio!).toLocaleDateString()}</span> a las <span style={{display: 'inline-block'}}>{new Date(accesoInicio!).toLocaleTimeString().substring(0,5)} hrs.</span></Alert>
                          :
                          (accesoInicio != "" || accesoFin != "") && (new Date(accesoInicio!) < new Date()) && (new Date(accesoFin!) < new Date()) ?
                          <Alert style={{ width: '100%' }} variant="outlined" severity="info">El periodo actual no está habilitado para realizar su proceso de matrícula de pregrado. Ante cualquier duda por favor comunicarse a través de <a style={{ fontWeight: 'bold' }} href="https://contacto.udd.cl/"><u>https://contacto.udd.cl/</u></a></Alert>
                         :""} */}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </div>}
          <Dialog open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="draggable-dialog-title">
            <DialogContent>
              <div style={{ textAlign: 'left', padding: 20, width: '20rem' }}>
                <Grid container spacing={0} item xs={12}>
                  <Grid item xs={10}>
                    <h5><span>Detalle: </span></h5>
                    <br></br>
                    {/* <p>Autorizado Matricularse: </p> */}
                    <p>¿ Tiene Deuda Finaciera ?: </p>
                    <p>¿ Tiene Deuda Biblioteca ?: </p>
                    <p>¿ Debe Documento LEM ?: </p>
                  </Grid>
                  <Grid item xs={2}>
                    <h5><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></h5>
                    <br></br>
                    <p>{deudaFinanciera.tieneDeuda ? (deudaFinanciera.autorizadoMatricula ? 'No' : 'Si') : 'No'}</p>
                    <p>{deudaBiblioteca ? 'Si' : 'No'}</p>
                    <p>{documentoLEM ? 'Si' : 'No'}</p>
                  </Grid>
                </Grid>
              </div>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={() => {
                setOpenModal(false)
              }} color="primary" >Salir</Button>
            </DialogActions>
          </Dialog>
        </div>
      }
      {
        openModalToken.open ?
          <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
          :
          ""
      }
    </>
  );
}

export default CarrerasPostuladas;